import { z } from "zod";

// Eklentiden gelen kazinmis veri "kirli" olabilir (bozuk gorsel URL'i, sayi yerine string vb.).
// Tek bir alan yuzunden tum istek reddedilmesin diye alanlar toleransli: gecersiz olanlar
// atilir/donusturulur; yalnizca url zorunlu.
export const createAnalysisSchema = z.object({
  url: z.string().url("Geçerli bir Etsy URL'si giriniz"),
  title: z.string().optional().catch(undefined),
  price: z.coerce.string().optional().catch(undefined),
  imageUrls: z
    .preprocess(
      (v) => (Array.isArray(v) ? v.filter((s) => typeof s === "string" && /^https?:\/\//i.test(s)) : []),
      z.array(z.string().url())
    )
    .catch([]),
  description: z.string().optional().catch(undefined),
  category: z.string().optional().catch(undefined),
  tags: z
    .preprocess(
      (v) => (Array.isArray(v) ? v.filter((s) => typeof s === "string" && s.trim().length > 0) : []),
      z.array(z.string())
    )
    .catch([]),
  rating: z.coerce.number().min(0).max(5).optional().catch(undefined),
  reviewCount: z.coerce.number().int().min(0).optional().catch(undefined),
  projectId: z.string().cuid().optional().catch(undefined),
  model: z.string().optional().catch(undefined),
  // Talep sinyalleri (liste sayfasi). DIKKAT: semada olmayan alan validate'te silinir.
  inCarts: z.coerce.number().int().min(0).optional().catch(undefined),
  recentPurchases: z.coerce.number().int().min(0).optional().catch(undefined),
  views24: z.coerce.number().int().min(0).optional().catch(undefined),
  salesCount: z.string().optional().catch(undefined),
  demandText: z.string().optional().catch(undefined),
  // Etsy API ozeti + eklentide kullanici esikleriyle hesaplanan potansiyel (arama karti rozetiyle ayni)
  etsyStats: z
    .object({
      views: z.number().nullable(), favorites: z.number(), ageDays: z.number(),
      viewsPerDay: z.number().nullable(), favPerDay: z.number(), potential: z.number(),
    })
    .partial()
    .optional()
    .catch(undefined),
  // Etsy "Personalize it" alanlari (varsa custom urun)
  personalization: z.any().optional().catch(undefined),
  // Eklentide secilen uretim zinciri: kategori, satan mockup, hedef magaza.
  // Hepsi opsiyonel — secilmezse analiz eskisi gibi olusur ve zincir
  // production-plan tarafindan kategori eslemesiyle cozulur.
  productTypeKey: z.string().optional().catch(undefined),
  sellingMockupId: z.string().optional().catch(undefined),
  shopId: z.string().optional().catch(undefined),
  // Eklentide secilen liste sablonu ve mockup gruplari (liste olusturulurken ilk oncelik)
  listingTemplateId: z.string().optional().catch(undefined),
  mockupCollectionIds: z.array(z.string()).optional().catch(undefined),
  // Custom listede kullanicinin kisisellestirme analizi icin sectigi gorseller
  // (ana gorsel + renk kartelasi, beden tablosu...). Verilirse analiz sonrasi
  // kisisellestirme haritasi da arka planda cikarilir.
  customImageUrls: z
    .preprocess(
      (v) => (Array.isArray(v) ? v.filter((s) => typeof s === "string" && /^https?:\/\//i.test(s)).slice(0, 6) : undefined),
      z.array(z.string().url()).optional()
    )
    .catch(undefined),
});

export type CreateAnalysisInput = z.infer<typeof createAnalysisSchema>;

export const analysisIdSchema = z.object({
  id: z.string().cuid("Geçersiz analysis ID"),
});
